/**
 * Polling Handlers Index
 *
 * Register all polling handlers here.
 */

import { registerPollingHandler, pollingService } from '../pollingService';
import { emailPollingHandler, createEmailPollingSource } from './emailPollingHandler';

export { emailPollingHandler, createEmailPollingSource };

/**
 * Register all polling handlers with the polling service
 */
export function registerAllPollingHandlers(): void {
  // Email polling via IMAP
  registerPollingHandler('email', emailPollingHandler);

  console.log('[PollingHandlers] All handlers registered');
}

/**
 * Setup default polling sources
 */
export function setupDefaultPollingSources(): void {
  // Add email inbox polling source
  pollingService.addSource(createEmailPollingSource({
    intervalMs: 30000, // 30 seconds
  }));

  console.log('[PollingHandlers] Default sources configured');
}
